import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

// Components
import TextInput from '../input-elements/oc-text-input';
import FormGroup from './oc-form-group';

const FormName = ({ columns, margin, required=false }) => {
  return (
    <FormGroup multipleFields={true} columns={columns} margin={margin}>
      <div>
        <TextInput name="first-name" label="First Name" required={required} />
      </div>

      <div>
        <TextInput name="last-name" label="Last Name" required={required} />
      </div>
    </FormGroup>
  )
}

export default FormName;

FormName.propTypes = {
  /** Set to true if you want a 2 column setup */
  columns: PropTypes.bool,
  /** set margin for multiple form groups */
  margin: PropTypes.string,
  /* Determines whether or not fields are required */
  required: PropTypes.bool
}
